import { render, staticRenderFns } from "./FUniswapPairDetail.vue?vue&type=template&id=180a905a&"
import script from "./FUniswapPairDetail.vue?vue&type=script&lang=js&"
export * from "./FUniswapPairDetail.vue?vue&type=script&lang=js&"
import style0 from "./FUniswapPairDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports